// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== Enhanced Pages.css — Blue/Purple Theme ===== */
:root {
    --primary:        #2874f0;
    --primary-dark:   #1a5fcf;
    --primary-light:  #4b8bff;
    --accent:         #764ba2;
    --accent-light:   #9b6fbe;
    --gradient-hero:  linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    --gradient-btn:   linear-gradient(135deg, #2874f0 0%, #4b8bff 100%);
    --bg-page:        #eef1f8;
    --bg-card:        #ffffff;
    --bg-panel:       #f4f7ff;
    --text-primary:   #1a1f36;
    --text-secondary: #5a6282;
    --border:         #d5daf0;
    --shadow-sm:      0 2px 8px rgba(40, 116, 240, 0.10);
    --shadow-md:      0 6px 24px rgba(40, 116, 240, 0.15);
    --shadow-lg:      0 12px 40px rgba(40, 116, 240, 0.20);
    --radius:         14px;
    --radius-lg:      20px;
}

/* ─── Page Wrapper ─── */
.pages-div-out {
    font-family: 'Segoe UI', Arial, sans-serif;
    width: 100%;
    max-width: 100%;
    padding-top: 32px;
    margin-bottom: 100px;
    overflow: hidden;
    background-color: var(--bg-page);
    padding-bottom: 60px;
}

@media (min-width: 1024px) {
  .pages-div-out {
    padding-top: 36px;
  }
}

/* ─── Top Create Section ─── */
.pages-create-display {
    display: flex;
    flex-direction: column;
    align-items: center;
    background: linear-gradient(160deg, #f0f4ff 0%, #e8eeff 100%);
    border-bottom: 2px solid var(--border);
    padding: 40px 48px 48px;
    width: 100%;
    box-sizing: border-box;
}

/* ─── Create Page Button ─── */
.btn-create-page {
    margin: 20px auto 30px;
    padding: 14px 32px;
    font-size: 16px;
    border-radius: 50px;
    background: var(--gradient-btn);
    color: #fff;
    min-width: 200px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    font-weight: 700;
    letter-spacing: 0.4px;
    box-shadow: 0 8px 24px rgba(40, 116, 240, 0.35);
    transition: all 0.25s ease;
    border: none;
    cursor: pointer;
}

.btn-create-page:hover {
    transform: translateY(-3px);
    box-shadow: 0 14px 32px rgba(40, 116, 240, 0.45);
    background: linear-gradient(135deg, #1f66d4 0%, #3b7df5 100%);
}

/* ─── Modal Overlay ─── */
.form-modal-page,
.form-modal-page-delete,
.form-modal-page-edit {
    background: rgba(15, 20, 50, 0.60);
    backdrop-filter: blur(6px);
    position: fixed;
    top: 0; left: 0;
    width: 100%; height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

/* ─── Modal Box ─── */
.form-content-page,
.form-content-page-edit,
.form-content-page-delete {
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #fff;
    padding: 36px 44px 40px;
    border-radius: var(--radius-lg);
    width: 90%;
    max-width: 580px;
    box-sizing: border-box;
    margin: 20px;
    box-shadow: 0 24px 64px rgba(40, 116, 240, 0.22);
    border-top: 5px solid var(--primary);
    animation: modalSlideIn 0.3s cubic-bezier(.22,.68,0,1.3);
}

.form-content-page-delete {
    align-items: flex-start;
    max-width: 420px;
}

@keyframes modalSlideIn {
    from { opacity: 0; transform: translateY(-24px) scale(0.97); }
    to   { opacity: 1; transform: translateY(0) scale(1); }
}

/* ─── Modal Title ─── */
.h3-page {
    font-size: 24px;
    font-weight: 700;
    margin: 0 0 24px;
    text-align: center;
    color: var(--text-primary);
    letter-spacing: -0.3px;
}

/* ─── Text Inputs Inside Modal ─── */
.text-page {
    padding: 14px 18px;
    margin-left: 0;
    margin-top: 14px;
    width: 100%;
    box-sizing: border-box;
    border: 1.5px solid var(--border);
    border-radius: 10px;
    font-size: 15px;
    color: var(--text-primary);
    background: #f8faff;
    transition: border-color 0.2s, box-shadow 0.2s;
    outline: none;
}

.text-page:focus {
    border-color: var(--primary);
    box-shadow: 0 0 0 3px rgba(40, 116, 240, 0.12);
    background: #fff;
}

/* ─── Modal Actions ─── */
.form-actions-page,
.form-actions-page-edit,
.form-actions-page-delete {
    display: flex;
    justify-content: center;
    gap: 16px;
    margin-top: 28px;
    flex-wrap: wrap;
    width: 100%;
}

.form-actions-page-edit,
.form-actions-page-delete {
    justify-content: flex-end;
    margin-right: 0;
}

.form-actions-page button,
.form-actions-page-edit button,
.form-actions-page-delete button {
    padding: 11px 28px;
    border-radius: 50px;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    border: none;
    transition: all 0.22s ease;
}

/* Next / primary action */
.form-actions-page button:first-child,
.form-actions-page-edit button:first-child,
.form-actions-page-delete button:first-child {
    background: var(--gradient-btn);
    color: #fff;
    box-shadow: 0 4px 14px rgba(40, 116, 240, 0.30);
}

.form-actions-page button:first-child:hover,
.form-actions-page-edit button:first-child:hover,
.form-actions-page-delete button:first-child:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(40, 116, 240, 0.40);
}

/* Cancel / secondary action */
.form-actions-page button:last-child,
.form-actions-page-edit button:last-child,
.form-actions-page-delete button:last-child {
    background: #f0f0f5;
    color: var(--text-secondary);
}

.form-actions-page button:last-child:hover,
.form-actions-page-edit button:last-child:hover,
.form-actions-page-delete button:last-child:hover {
    background: #e4e4ef;
    color: var(--text-primary);
    transform: translateY(-1px);
}

/* ─── Sections List ─── */
.pages-list-pro {
    margin: 0 auto;
    max-width: 1600px;
    text-align: center;
    padding: 24px 0;
    list-style: none;
    width: 100%;
}

/* ─── Section Title ─── */
.pages-section-title {
    font-size: 26px;
    font-weight: 700;
    margin-bottom: 24px;
    color: var(--primary);
    text-align: left;
    padding-left: 4px;
    display: flex;
    align-items: center;
    gap: 10px;
}

.pages-section-title::before {
    content: '';
    display: inline-block;
    width: 5px;
    height: 26px;
    background: var(--gradient-btn);
    border-radius: 4px;
    flex-shrink: 0;
}

/* ─── Grid ─── */
.pages-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 24px;
    width: 100%;
    margin: 0 auto;
}

@media (min-width: 1400px) {
    .pages-grid {
        grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
        max-width: 1600px;
    }
}

/* ─── Card ─── */
.page-card-modern {
    background: var(--bg-card);
    border-radius: var(--radius);
    border: 1px solid var(--border);
    box-shadow: var(--shadow-sm);
    overflow: hidden;
    transition: all 0.3s ease;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    height: 100%;
}

.page-card-modern:hover {
    transform: translateY(-6px);
    box-shadow: var(--shadow-lg);
    border-color: rgba(40, 116, 240, 0.30);
}

/* ─── Card Image Area ─── */
.page-card-image-container {
    position: relative;
    width: 100%;
    height: 148px;
    overflow: hidden;
    background: var(--gradient-hero);
}

.page-card-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.35s ease;
}

.page-card-modern:hover .page-card-image {
    transform: scale(1.08);
}

.page-card-placeholder {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--gradient-hero);
}

.page-card-placeholder-icon {
    font-size: 64px;
    opacity: 0.65;
}

.page-card-overlay {
    position: absolute;
    inset: 0;
    background: linear-gradient(180deg, rgba(40,116,240,0.55) 0%, rgba(118,75,162,0.70) 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: opacity 0.3s ease;
}

.page-card-modern:hover .page-card-overlay {
    opacity: 1;
}

.page-card-view-text {
    color: #fff;
    font-weight: 700;
    font-size: 15px;
    text-transform: uppercase;
    letter-spacing: 1.5px;
    background: rgba(255,255,255,0.15);
    padding: 8px 20px;
    border-radius: 50px;
    backdrop-filter: blur(4px);
    border: 1.5px solid rgba(255,255,255,0.45);
}

/* ─── Card Body ─── */
.page-card-content {
    padding: 20px;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    background: linear-gradient(180deg, #fff 0%, #f8faff 100%);
}

.page-card-title {
    font-size: 18px;
    font-weight: 700;
    color: var(--text-primary);
    margin: 0 0 8px;
    cursor: pointer;
    transition: color 0.2s ease;
}

.page-card-title:hover {
    color: var(--primary);
}

.page-card-description {
    font-size: 13.5px;
    color: var(--text-secondary);
    line-height: 1.6;
    margin: 0 0 16px;
    flex-grow: 1;
}

/* ─── Card Actions ─── */
.page-card-actions {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    margin-top: auto;
}

.page-card-edit-btn,
.page-card-view-btn {
    background: var(--gradient-btn);
    color: #fff;
    border: none;
    padding: 9px 18px;
    border-radius: 8px;
    font-size: 13.5px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.22s ease;
    flex: 1 1;
    box-shadow: 0 2px 8px rgba(40, 116, 240, 0.20);
}

.page-card-edit-btn:hover,
.page-card-view-btn:hover {
    background: linear-gradient(135deg, #1a5fcf 0%, #3b7df5 100%);
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(40, 116, 240, 0.35);
}

.page-card-delete-btn {
    background: transparent;
    border: 1.5px solid var(--border);
    padding: 9px 12px;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.22s ease;
    display: flex;
    align-items: center;
    justify-content: center;
}

.page-card-delete-btn:hover {
    background: #fff0f0;
    border-color: #ff6161;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(255, 97, 97, 0.20);
}

/* ─── States ─── */
.loading-state,
.empty-state {
    text-align: center;
    padding: 48px 20px;
    color: var(--text-secondary);
    font-size: 16px;
}

/* ─── More Button ─── */
.more-button-modern {
    background: #fff;
    border: 1.5px solid var(--border);
    color: var(--text-secondary);
    padding: 12px 28px;
    border-radius: 50px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.22s ease;
    margin: 32px auto;
    display: flex;
    align-items: center;
    gap: 8px;
    box-shadow: var(--shadow-sm);
}

.more-button-modern:hover {
    background: #f0f5ff;
    border-color: var(--primary);
    color: var(--primary);
    transform: translateY(-2px);
    box-shadow: var(--shadow-md);
}

/* ─── Two-Column Layout ─── */
.pages-two-columns {
    display: flex;
    flex-direction: row;
    gap: 36px;
    width: 100%;
    margin-top: 16px;
    align-items: flex-start;
    box-sizing: border-box;
}

.pages-two-columns .pages-list-pro {
    flex: 1 1;
    min-width: 0;
    background: var(--bg-panel);
    border-radius: var(--radius-lg);
    padding: 28px 24px 24px;
    border-top: 4px solid var(--primary);
    box-shadow: var(--shadow-sm);
    transition: box-shadow 0.25s;
    box-sizing: border-box;
    overflow: hidden;
    margin: 0;
}

.pages-two-columns .pages-list-pro:hover {
    box-shadow: var(--shadow-md);
}

.pages-two-columns .pages-grid {
    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
    gap: 16px;
}

.pages-two-columns .pages-section-title {
    font-size: 20px;
    font-weight: 700;
    color: var(--primary);
    margin-bottom: 20px;
    letter-spacing: 0.2px;
}

/* ─── Pro Card List ─── */
.page-card-pro,
.page-card-pro-i {
    display: flex;
    justify-content: space-between;
    gap: 10px;
    padding: 12px 16px;
    margin: 10px auto;
    border-radius: 10px;
    background: #fff;
    border: 1px solid var(--border);
    width: 100%;
    min-width: 400px;
    box-sizing: border-box;
    transition: box-shadow 0.2s, transform 0.2s;
}

.page-card-pro:hover,
.page-card-pro-i:hover {
    box-shadow: var(--shadow-sm);
    transform: translateY(-2px);
}

.view-btn-page,
.delete-btn-page-list,
.edit-btn-page-dete {
    background-color: transparent;
    font-size: 12px;
    padding: 4px 8px;
    border-radius: 6px;
    transition: background 0.15s, color 0.15s;
    cursor: pointer;
    border: none;
}

.view-btn-page:hover       { background: #e8f0fe; color: var(--primary); }
.delete-btn-page-list:hover{ background: #fff0f0; color: #e53935; }
.edit-btn-page-dete:hover  { background: #e8f0fe; color: var(--primary); }

.btn-view-delete {
    display: flex;
    flex-direction: row;
    gap: 6px;
    justify-content: flex-end;
    align-items: center;
}

/* ─── Close Button ─── */
.close-btn-page-list {
    background-color: transparent;
    color: white;
    padding: 4px;
    border: none;
    cursor: pointer;
    border-radius: 50%;
    transition: background 0.15s;
}

.close-btn-page-list:hover {
    background-color: rgba(255,255,255,0.15);
    color: #ff6b6b;
}

/* ─── Flipkart-style Buttons ─── */
.flipkart-button-primary {
    background: var(--gradient-btn);
    color: #fff;
    border: none;
    padding: 10px 22px;
    border-radius: 8px;
    font-weight: 600;
    cursor: pointer;
    box-shadow: 0 2px 8px rgba(40, 116, 240, 0.25);
    transition: all 0.25s ease;
}

.flipkart-button-primary:hover {
    background: linear-gradient(135deg, #1a5fcf 0%, #3b7df5 100%);
    box-shadow: 0 6px 18px rgba(40, 116, 240, 0.35);
    transform: translateY(-1px);
}

.flipkart-button-primary:disabled {
    background: #cccccc;
    cursor: not-allowed;
    box-shadow: none;
}

.flipkart-button-secondary {
    background: #fff;
    color: var(--primary);
    border: 1.5px solid var(--primary);
    padding: 10px 22px;
    border-radius: 8px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.22s ease;
}

.flipkart-button-secondary:hover {
    background: #eef3ff;
    transform: translateY(-1px);
}

.flipkart-button-secondary.small {
    padding: 5px 12px;
    font-size: 12px;
}

.flipkart-button-danger {
    background: linear-gradient(135deg, #ff6161 0%, #e53935 100%);
    color: #fff;
    border: none;
    padding: 10px 22px;
    border-radius: 8px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.22s ease;
    box-shadow: 0 2px 8px rgba(229, 57, 53, 0.25);
}

.flipkart-button-danger:hover {
    background: linear-gradient(135deg, #e53935 0%, #c62828 100%);
    transform: translateY(-1px);
    box-shadow: 0 6px 16px rgba(229, 57, 53, 0.35);
}

.flipkart-button-danger.small {
    padding: 5px 12px;
    font-size: 12px;
}

/* ─── Flipkart Modal ─── */
.flipkart-modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(15, 20, 50, 0.60);
    backdrop-filter: blur(6px);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.flipkart-modal-container {
    background: #fff;
    border-radius: var(--radius-lg);
    width: 100%;
    max-width: 600px;
    box-shadow: 0 24px 64px rgba(40, 116, 240, 0.22);
    border-top: 5px solid var(--primary);
    animation: flipkartModalFadeIn 0.3s cubic-bezier(.22,.68,0,1.3);
}

.flipkart-modal-container.small {
    max-width: 420px;
}

@keyframes flipkartModalFadeIn {
    from { opacity: 0; transform: translateY(-20px) scale(0.97); }
    to   { opacity: 1; transform: translateY(0) scale(1); }
}

.flipkart-modal-header {
    padding: 24px 36px;
    border-bottom: 1px solid var(--border);
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: linear-gradient(135deg, #f4f7ff 0%, #eef1ff 100%);
    border-radius: var(--radius-lg) var(--radius-lg) 0 0;
}

.flipkart-modal-header h3 {
    margin: 0;
    font-size: 22px;
    font-weight: 700;
    color: var(--text-primary);
}

.flipkart-modal-close {
    background: none;
    border: none;
    font-size: 22px;
    cursor: pointer;
    color: var(--text-secondary);
    padding: 4px 8px;
    border-radius: 50%;
    line-height: 1;
    transition: background 0.2s, color 0.2s;
}

.flipkart-modal-close:hover {
    background: #ffe8e8;
    color: #e53935;
}

.flipkart-modal-body {
    padding: 28px 36px;
    max-height: 60vh;
    overflow-y: auto;
}

.scrollable-content {
    max-height: 50vh;
    overflow-y: auto;
}

.flipkart-modal-footer {
    padding: 18px 36px;
    border-top: 1px solid var(--border);
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    background: #fafbff;
    border-radius: 0 0 var(--radius-lg) var(--radius-lg);
}

/* ─── Form Inputs (Flipkart style) ─── */
.flipkart-form-group {
    margin-bottom: 18px;
}

.flipkart-form-group label {
    display: block;
    margin-bottom: 8px;
    font-size: 14px;
    color: var(--text-primary);
    font-weight: 600;
}

.flipkart-input {
    width: 100%;
    padding: 11px 14px;
    border: 1.5px solid var(--border);
    border-radius: 10px;
    font-size: 14px;
    background: #f8faff;
    color: var(--text-primary);
    transition: border-color 0.2s, box-shadow 0.2s;
    outline: none;
    box-sizing: border-box;
}

.flipkart-input:focus {
    border-color: var(--primary);
    box-shadow: 0 0 0 3px rgba(40, 116, 240, 0.12);
    background: #fff;
}

.flipkart-textarea {
    width: 100%;
    padding: 11px 14px;
    border: 1.5px solid var(--border);
    border-radius: 10px;
    font-size: 14px;
    min-height: 90px;
    resize: vertical;
    background: #f8faff;
    color: var(--text-primary);
    transition: border-color 0.2s, box-shadow 0.2s;
    outline: none;
    box-sizing: border-box;
    margin-bottom: 8px;
}

.flipkart-textarea:focus {
    border-color: var(--primary);
    box-shadow: 0 0 0 3px rgba(40, 116, 240, 0.12);
    background: #fff;
}

.flipkart-file-input {
    width: 100%;
    padding: 8px 0;
    font-size: 14px;
}

.paragraph-group {
    margin-bottom: 14px;
}

/* ─── Type Selection Buttons ─── */
.btn-select-type {
    width: 180px;
    height: 130px;
    border-radius: var(--radius);
    border: none;
    padding: 20px;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-shadow: 0 6px 20px rgba(0,0,0,0.14);
}

.firm-btn {
    background: linear-gradient(135deg, #4b6cb7 0%, #182848 100%);
    color: #fff;
}

.individual-btn {
    background: linear-gradient(135deg, #ff7e5f 0%, #feb47b 100%);
    color: #fff;
}

.btn-select-type:hover {
    transform: translateY(-6px);
    box-shadow: 0 14px 32px rgba(0,0,0,0.22);
}

.btn-icon        { font-size: 36px;  margin-bottom: 10px; }
.btn-text        { font-size: 20px;  font-weight: 700; margin-bottom: 8px; }
.btn-description { font-size: 13px;  opacity: 0.88; }

/* ─── Back Button ─── */
.btn-back-outline {
    background: transparent;
    border: 2px solid var(--border);
    color: var(--text-secondary);
    padding: 9px 22px;
    border-radius: 50px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.25s ease;
    margin-top: 20px;
    display: inline-flex;
    align-items: center;
    gap: 6px;
}

.btn-back-outline:hover {
    background: #eef1ff;
    border-color: var(--primary);
    color: var(--primary);
    transform: translateY(-1px);
}

/* ─── Validation ─── */
.error-field {
    border: 1.5px solid #e53935 !important;
    background: #fff8f8 !important;
}

.error-message {
    color: #e53935;
    font-size: 12px;
    margin-top: 5px;
    display: flex;
    align-items: center;
    gap: 4px;
}

.required-star { color: #e53935; }

/* ─── Responsive ─── */
@media (max-width: 900px) {
    .pages-two-columns {
        flex-direction: column;
        gap: 24px;
    }

    .pages-two-columns .pages-list-pro {
        width: 100%;
    }
}

@media (max-width: 1024px) and (min-width: 768px) {
    .pages-div-out      { margin-top: 70px; padding-top: 28px; }
    .pages-create-display { padding: 30px 40px; }
}

/* ─── MOBILE: ≤ 768px ─── */
@media (max-width: 768px) {
    .pages-div-out        { margin-top: 20px; padding-top: 20px; margin-bottom: 50px; }
    .pages-create-display { padding: 0px 16px 20px; }
    .pages-grid           { grid-template-columns: repeat(auto-fill, minmax(130px, 1fr)); gap: 10px; }
    .page-card-image-container { height: 90px; }
    .page-card-placeholder-icon { font-size: 40px; }
    .page-card-content    { padding: 10px; }
    .page-card-title      { font-size: 13px; margin-bottom: 4px; }
    .page-card-description{
        font-size: 11.5px;
        line-height: 1.4;
        margin-bottom: 10px;
        -webkit-line-clamp: 2;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }
    .page-card-edit-btn,
    .page-card-view-btn   { padding: 6px 8px; font-size: 11.5px; }
    .page-card-delete-btn { padding: 6px 8px; }
    .pages-section-title  { font-size: 20px; }
    .text-page            { margin-left: 0; }
    .form-actions-page,
    .form-actions-page-edit { gap: 10px; justify-content: center; }
    .flipkart-modal-body  { padding: 20px 24px; }
    .flipkart-modal-header { padding: 18px 24px; }
    .flipkart-modal-footer { padding: 14px 24px; }

    .pages-two-columns {
        flex-direction: column;
        gap: 16px;
    }

    .pages-two-columns .pages-list-pro {
        width: 100%;
        padding: 16px 12px;
    }

    .pages-two-columns .pages-grid {
        grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
        gap: 10px;
    }
}

/* ─── MOBILE: ≤ 480px ─── */
@media (max-width: 480px) {
    .pages-div-out        { margin-top: 35px; padding-top: 16px; }
    .pages-create-display { padding: 5px 10px 18px; }
    .pages-grid           { grid-template-columns: 1fr 1fr; gap: 8px; }
    .page-card-image-container { height: 80px; }
    .page-card-placeholder-icon { font-size: 34px; }
    .page-card-content    { padding: 8px 10px; }
    .page-card-title      { font-size: 12px; margin-bottom: 3px; }
    .page-card-description{
        font-size: 11px;
        line-height: 1.35;
        margin-bottom: 8px;
        -webkit-line-clamp: 2;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }
    .page-card-actions    { gap: 5px; }
    .page-card-edit-btn,
    .page-card-view-btn   { padding: 5px 6px; font-size: 11px; }
    .page-card-delete-btn { padding: 5px 8px; }
    .pages-section-title  { font-size: 16px; margin-bottom: 12px; }
    .btn-create-page      { padding: 10px 20px; font-size: 13px; min-width: 150px; margin-bottom: 0px; }
    .form-actions-page button,
    .form-actions-page-delete button,
    .form-actions-page-edit button { padding: 9px 16px; font-size: 13px; }
    .page-card-pro,
    .page-card-pro-i      { min-width: unset; flex-wrap: wrap; }
    .view-btn-page,
    .edit-btn-page-dete   { width: 100%; padding: 6px; margin: 2px 0; }
    .pages-two-columns .pages-grid {
        grid-template-columns: 1fr 1fr;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Pages.css"],"names":[],"mappings":"AAAA,uDAAuD;AACvD;IACI,yBAAyB;IACzB,yBAAyB;IACzB,yBAAyB;IACzB,yBAAyB;IACzB,yBAAyB;IACzB,mEAAmE;IACnE,mEAAmE;IACnE,yBAAyB;IACzB,yBAAyB;IACzB,yBAAyB;IACzB,yBAAyB;IACzB,yBAAyB;IACzB,yBAAyB;IACzB,oDAAoD;IACpD,qDAAqD;IACrD,sDAAsD;IACtD,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA,yBAAyB;AACzB;IACI,0CAA0C;IAC1C,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;IAChB,gCAAgC;IAChC,oBAAoB;AACxB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA,+BAA+B;AAC/B;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,6DAA6D;IAC7D,sCAAsC;IACtC,uBAAuB;IACvB,WAAW;IACX,sBAAsB;AAC1B;;AAEA,+BAA+B;AAC/B;IACI,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,+BAA+B;IAC/B,WAAW;IACX,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,gBAAgB;IAChB,qBAAqB;IACrB,+CAA+C;IAC/C,0BAA0B;IAC1B,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,2BAA2B;IAC3B,gDAAgD;IAChD,6DAA6D;AACjE;;AAEA,0BAA0B;AAC1B;;;IAGI,kCAAkC;IAClC,0BAA0B;IAC1B,eAAe;IACf,MAAM,EAAE,OAAO;IACf,WAAW,EAAE,YAAY;IACzB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA,sBAAsB;AACtB;;;IAGI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,+BAA+B;IAC/B,UAAU;IACV,gBAAgB;IAChB,sBAAsB;IACtB,YAAY;IACZ,gDAAgD;IAChD,oCAAoC;IACpC,wDAAwD;AAC5D;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,OAAO,UAAU,EAAE,wCAAwC,EAAE;IAC7D,OAAO,UAAU,EAAE,iCAAiC,EAAE;AAC1D;;AAEA,wBAAwB;AACxB;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,0BAA0B;IAC1B,sBAAsB;AAC1B;;AAEA,qCAAqC;AACrC;IACI,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,WAAW;IACX,sBAAsB;IACtB,iCAAiC;IACjC,mBAAmB;IACnB,eAAe;IACf,0BAA0B;IAC1B,mBAAmB;IACnB,8CAA8C;IAC9C,aAAa;AACjB;;AAEA;IACI,4BAA4B;IAC5B,8CAA8C;IAC9C,gBAAgB;AACpB;;AAEA,0BAA0B;AAC1B;;;IAGI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,gBAAgB;IAChB,eAAe;IACf,WAAW;AACf;;AAEA;;IAEI,yBAAyB;IACzB,eAAe;AACnB;;AAEA;;;IAGI,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,0BAA0B;AAC9B;;AAEA,0BAA0B;AAC1B;;;IAGI,+BAA+B;IAC/B,WAAW;IACX,+CAA+C;AACnD;;AAEA;;;IAGI,2BAA2B;IAC3B,+CAA+C;AACnD;;AAEA,8BAA8B;AAC9B;;;IAGI,mBAAmB;IACnB,4BAA4B;AAChC;;AAEA;;;IAGI,mBAAmB;IACnB,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA,0BAA0B;AAC1B;IACI,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA,0BAA0B;AAC1B;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,qBAAqB;IACrB,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,UAAU;IACV,YAAY;IACZ,+BAA+B;IAC/B,kBAAkB;IAClB,cAAc;AAClB;;AAEA,iBAAiB;AACjB;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;IACT,WAAW;IACX,cAAc;AAClB;;AAEA;IACI;QACI,4DAA4D;QAC5D,iBAAiB;IACrB;AACJ;;AAEA,iBAAiB;AACjB;IACI,0BAA0B;IAC1B,4BAA4B;IAC5B,+BAA+B;IAC/B,4BAA4B;IAC5B,gBAAgB;IAChB,yBAAyB;IACzB,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,2BAA2B;IAC3B,4BAA4B;IAC5B,sCAAsC;AAC1C;;AAEA,4BAA4B;AAC5B;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,yFAAyF;IACzF,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,6BAA6B;AACjC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,qBAAqB;IACrB,kCAAkC;IAClC,iBAAiB;IACjB,mBAAmB;IACnB,0BAA0B;IAC1B,0CAA0C;AAC9C;;AAEA,sBAAsB;AACtB;IACI,aAAa;IACb,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,0DAA0D;AAC9D;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,eAAe;IACf,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,4BAA4B;IAC5B,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;AAChB;;AAEA,yBAAyB;AACzB;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,gBAAgB;AACpB;;AAEA;;IAEI,+BAA+B;IAC/B,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,0BAA0B;IAC1B,SAAO;IACP,8CAA8C;AAClD;;AAEA;;IAEI,6DAA6D;IAC7D,2BAA2B;IAC3B,+CAA+C;AACnD;;AAEA;IACI,uBAAuB;IACvB,iCAAiC;IACjC,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,2BAA2B;IAC3B,8CAA8C;AAClD;;AAEA,mBAAmB;AACnB;;IAEI,kBAAkB;IAClB,kBAAkB;IAClB,4BAA4B;IAC5B,eAAe;AACnB;;AAEA,wBAAwB;AACxB;IACI,gBAAgB;IAChB,iCAAiC;IACjC,4BAA4B;IAC5B,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,0BAA0B;IAC1B,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;IACnB,4BAA4B;IAC5B,qBAAqB;IACrB,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA,8BAA8B;AAC9B;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,SAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,+BAA+B;IAC/B,uBAAuB;IACvB,oCAAoC;IACpC,4BAA4B;IAC5B,4BAA4B;IAC5B,sBAAsB;IACtB,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,4DAA4D;IAC5D,SAAS;AACb;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA,0BAA0B;AAC1B;;IAEI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,+BAA+B;IAC/B,WAAW;IACX,gBAAgB;IAChB,sBAAsB;IACtB,2CAA2C;AAC/C;;AAEA;;IAEI,4BAA4B;IAC5B,2BAA2B;AAC/B;;AAEA;;;IAGI,6BAA6B;IAC7B,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,yCAAyC;IACzC,eAAe;IACf,YAAY;AAChB;;AAEA,6BAA6B,mBAAmB,EAAE,qBAAqB,EAAE;AACzE,6BAA6B,mBAAmB,EAAE,cAAc,EAAE;AAClE,6BAA6B,mBAAmB,EAAE,qBAAqB,EAAE;;AAEzE;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA,yBAAyB;AACzB;IACI,6BAA6B;IAC7B,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA;IACI,wCAAwC;IACxC,cAAc;AAClB;;AAEA,mCAAmC;AACnC;IACI,+BAA+B;IAC/B,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,8CAA8C;IAC9C,0BAA0B;AAC9B;;AAEA;IACI,6DAA6D;IAC7D,+CAA+C;IAC/C,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,kCAAkC;IAClC,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,6DAA6D;IAC7D,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,0BAA0B;IAC1B,6CAA6C;AACjD;;AAEA;IACI,6DAA6D;IAC7D,2BAA2B;IAC3B,8CAA8C;AAClD;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA,2BAA2B;AAC3B;IACI,eAAe;IACf,QAAQ;IACR,kCAAkC;IAClC,0BAA0B;IAC1B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,+BAA+B;IAC/B,WAAW;IACX,gBAAgB;IAChB,gDAAgD;IAChD,oCAAoC;IACpC,+DAA+D;AACnE;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,OAAO,UAAU,EAAE,wCAAwC,EAAE;IAC7D,OAAO,UAAU,EAAE,iCAAiC,EAAE;AAC1D;;AAEA;IACI,kBAAkB;IAClB,sCAAsC;IACtC,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,6DAA6D;IAC7D,oDAAoD;AACxD;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,4BAA4B;IAC5B,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,uCAAuC;AAC3C;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,mCAAmC;IACnC,aAAa;IACb,yBAAyB;IACzB,SAAS;IACT,mBAAmB;IACnB,oDAAoD;AACxD;;AAEA,yCAAyC;AACzC;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,iCAAiC;IACjC,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,0BAA0B;IAC1B,8CAA8C;IAC9C,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,4BAA4B;IAC5B,8CAA8C;IAC9C,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,iCAAiC;IACjC,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,0BAA0B;IAC1B,8CAA8C;IAC9C,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,4BAA4B;IAC5B,8CAA8C;IAC9C,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,mCAAmC;AACnC;IACI,YAAY;IACZ,aAAa;IACb,4BAA4B;IAC5B,YAAY;IACZ,aAAa;IACb,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,uCAAuC;AAC3C;;AAEA;IACI,6DAA6D;IAC7D,WAAW;AACf;;AAEA;IACI,6DAA6D;IAC7D,WAAW;AACf;;AAEA;IACI,2BAA2B;IAC3B,wCAAwC;AAC5C;;AAEA,mBAAmB,eAAe,GAAG,mBAAmB,EAAE;AAC1D,mBAAmB,eAAe,GAAG,gBAAgB,EAAE,kBAAkB,EAAE;AAC3E,mBAAmB,eAAe,GAAG,aAAa,EAAE;;AAEpD,wBAAwB;AACxB;IACI,uBAAuB;IACvB,+BAA+B;IAC/B,4BAA4B;IAC5B,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,0BAA0B;IAC1B,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,mBAAmB;IACnB,4BAA4B;IAC5B,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA,uBAAuB;AACvB;IACI,sCAAsC;IACtC,8BAA8B;AAClC;;AAEA;IACI,cAAc;IACd,eAAe;IACf,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA,iBAAiB,cAAc,EAAE;;AAEjC,uBAAuB;AACvB;IACI;QACI,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA;IACI,sBAAsB,gBAAgB,EAAE,iBAAiB,EAAE;IAC3D,wBAAwB,kBAAkB,EAAE;AAChD;;AAEA,4BAA4B;AAC5B;IACI,wBAAwB,gBAAgB,EAAE,iBAAiB,EAAE,mBAAmB,EAAE;IAClF,wBAAwB,sBAAsB,EAAE;IAChD,wBAAwB,4DAA4D,EAAE,SAAS,EAAE;IACjG,6BAA6B,YAAY,EAAE;IAC3C,8BAA8B,eAAe,EAAE;IAC/C,wBAAwB,aAAa,EAAE;IACvC,wBAAwB,eAAe,EAAE,kBAAkB,EAAE;IAC7D;QACI,iBAAiB;QACjB,gBAAgB;QAChB,mBAAmB;QACnB,qBAAqB;QACrB,oBAAoB;QACpB,4BAA4B;QAC5B,gBAAgB;IACpB;IACA;4BACwB,gBAAgB,EAAE,iBAAiB,EAAE;IAC7D,wBAAwB,gBAAgB,EAAE;IAC1C,wBAAwB,eAAe,EAAE;IACzC,wBAAwB,cAAc,EAAE;IACxC;8BAC0B,SAAS,EAAE,uBAAuB,EAAE;IAC9D,wBAAwB,kBAAkB,EAAE;IAC5C,yBAAyB,kBAAkB,EAAE;IAC7C,yBAAyB,kBAAkB,EAAE;;IAE7C;QACI,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,WAAW;QACX,kBAAkB;IACtB;;IAEA;QACI,4DAA4D;QAC5D,SAAS;IACb;AACJ;;AAEA,4BAA4B;AAC5B;IACI,wBAAwB,gBAAgB,EAAE,iBAAiB,EAAE;IAC7D,wBAAwB,sBAAsB,EAAE;IAChD,wBAAwB,8BAA8B,EAAE,QAAQ,EAAE;IAClE,6BAA6B,YAAY,EAAE;IAC3C,8BAA8B,eAAe,EAAE;IAC/C,wBAAwB,iBAAiB,EAAE;IAC3C,wBAAwB,eAAe,EAAE,kBAAkB,EAAE;IAC7D;QACI,eAAe;QACf,iBAAiB;QACjB,kBAAkB;QAClB,qBAAqB;QACrB,oBAAoB;QACpB,4BAA4B;QAC5B,gBAAgB;IACpB;IACA,wBAAwB,QAAQ,EAAE;IAClC;4BACwB,gBAAgB,EAAE,eAAe,EAAE;IAC3D,wBAAwB,gBAAgB,EAAE;IAC1C,wBAAwB,eAAe,EAAE,mBAAmB,EAAE;IAC9D,wBAAwB,kBAAkB,EAAE,eAAe,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;IACnG;;qCAEiC,iBAAiB,EAAE,eAAe,EAAE;IACrE;4BACwB,gBAAgB,EAAE,eAAe,EAAE;IAC3D;4BACwB,WAAW,EAAE,YAAY,EAAE,aAAa,EAAE;IAClE;QACI,8BAA8B;IAClC;AACJ","sourcesContent":["/* ===== Enhanced Pages.css — Blue/Purple Theme ===== */\n:root {\n    --primary:        #2874f0;\n    --primary-dark:   #1a5fcf;\n    --primary-light:  #4b8bff;\n    --accent:         #764ba2;\n    --accent-light:   #9b6fbe;\n    --gradient-hero:  linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    --gradient-btn:   linear-gradient(135deg, #2874f0 0%, #4b8bff 100%);\n    --bg-page:        #eef1f8;\n    --bg-card:        #ffffff;\n    --bg-panel:       #f4f7ff;\n    --text-primary:   #1a1f36;\n    --text-secondary: #5a6282;\n    --border:         #d5daf0;\n    --shadow-sm:      0 2px 8px rgba(40, 116, 240, 0.10);\n    --shadow-md:      0 6px 24px rgba(40, 116, 240, 0.15);\n    --shadow-lg:      0 12px 40px rgba(40, 116, 240, 0.20);\n    --radius:         14px;\n    --radius-lg:      20px;\n}\n\n/* ─── Page Wrapper ─── */\n.pages-div-out {\n    font-family: 'Segoe UI', Arial, sans-serif;\n    width: 100%;\n    max-width: 100%;\n    padding-top: 32px;\n    margin-bottom: 100px;\n    overflow: hidden;\n    background-color: var(--bg-page);\n    padding-bottom: 60px;\n}\n\n@media (min-width: 1024px) {\n  .pages-div-out {\n    padding-top: 36px;\n  }\n}\n\n/* ─── Top Create Section ─── */\n.pages-create-display {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    background: linear-gradient(160deg, #f0f4ff 0%, #e8eeff 100%);\n    border-bottom: 2px solid var(--border);\n    padding: 40px 48px 48px;\n    width: 100%;\n    box-sizing: border-box;\n}\n\n/* ─── Create Page Button ─── */\n.btn-create-page {\n    margin: 20px auto 30px;\n    padding: 14px 32px;\n    font-size: 16px;\n    border-radius: 50px;\n    background: var(--gradient-btn);\n    color: #fff;\n    min-width: 200px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n    font-weight: 700;\n    letter-spacing: 0.4px;\n    box-shadow: 0 8px 24px rgba(40, 116, 240, 0.35);\n    transition: all 0.25s ease;\n    border: none;\n    cursor: pointer;\n}\n\n.btn-create-page:hover {\n    transform: translateY(-3px);\n    box-shadow: 0 14px 32px rgba(40, 116, 240, 0.45);\n    background: linear-gradient(135deg, #1f66d4 0%, #3b7df5 100%);\n}\n\n/* ─── Modal Overlay ─── */\n.form-modal-page,\n.form-modal-page-delete,\n.form-modal-page-edit {\n    background: rgba(15, 20, 50, 0.60);\n    backdrop-filter: blur(6px);\n    position: fixed;\n    top: 0; left: 0;\n    width: 100%; height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n}\n\n/* ─── Modal Box ─── */\n.form-content-page,\n.form-content-page-edit,\n.form-content-page-delete {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    background: #fff;\n    padding: 36px 44px 40px;\n    border-radius: var(--radius-lg);\n    width: 90%;\n    max-width: 580px;\n    box-sizing: border-box;\n    margin: 20px;\n    box-shadow: 0 24px 64px rgba(40, 116, 240, 0.22);\n    border-top: 5px solid var(--primary);\n    animation: modalSlideIn 0.3s cubic-bezier(.22,.68,0,1.3);\n}\n\n.form-content-page-delete {\n    align-items: flex-start;\n    max-width: 420px;\n}\n\n@keyframes modalSlideIn {\n    from { opacity: 0; transform: translateY(-24px) scale(0.97); }\n    to   { opacity: 1; transform: translateY(0) scale(1); }\n}\n\n/* ─── Modal Title ─── */\n.h3-page {\n    font-size: 24px;\n    font-weight: 700;\n    margin: 0 0 24px;\n    text-align: center;\n    color: var(--text-primary);\n    letter-spacing: -0.3px;\n}\n\n/* ─── Text Inputs Inside Modal ─── */\n.text-page {\n    padding: 14px 18px;\n    margin-left: 0;\n    margin-top: 14px;\n    width: 100%;\n    box-sizing: border-box;\n    border: 1.5px solid var(--border);\n    border-radius: 10px;\n    font-size: 15px;\n    color: var(--text-primary);\n    background: #f8faff;\n    transition: border-color 0.2s, box-shadow 0.2s;\n    outline: none;\n}\n\n.text-page:focus {\n    border-color: var(--primary);\n    box-shadow: 0 0 0 3px rgba(40, 116, 240, 0.12);\n    background: #fff;\n}\n\n/* ─── Modal Actions ─── */\n.form-actions-page,\n.form-actions-page-edit,\n.form-actions-page-delete {\n    display: flex;\n    justify-content: center;\n    gap: 16px;\n    margin-top: 28px;\n    flex-wrap: wrap;\n    width: 100%;\n}\n\n.form-actions-page-edit,\n.form-actions-page-delete {\n    justify-content: flex-end;\n    margin-right: 0;\n}\n\n.form-actions-page button,\n.form-actions-page-edit button,\n.form-actions-page-delete button {\n    padding: 11px 28px;\n    border-radius: 50px;\n    font-size: 15px;\n    font-weight: 600;\n    cursor: pointer;\n    border: none;\n    transition: all 0.22s ease;\n}\n\n/* Next / primary action */\n.form-actions-page button:first-child,\n.form-actions-page-edit button:first-child,\n.form-actions-page-delete button:first-child {\n    background: var(--gradient-btn);\n    color: #fff;\n    box-shadow: 0 4px 14px rgba(40, 116, 240, 0.30);\n}\n\n.form-actions-page button:first-child:hover,\n.form-actions-page-edit button:first-child:hover,\n.form-actions-page-delete button:first-child:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 8px 20px rgba(40, 116, 240, 0.40);\n}\n\n/* Cancel / secondary action */\n.form-actions-page button:last-child,\n.form-actions-page-edit button:last-child,\n.form-actions-page-delete button:last-child {\n    background: #f0f0f5;\n    color: var(--text-secondary);\n}\n\n.form-actions-page button:last-child:hover,\n.form-actions-page-edit button:last-child:hover,\n.form-actions-page-delete button:last-child:hover {\n    background: #e4e4ef;\n    color: var(--text-primary);\n    transform: translateY(-1px);\n}\n\n/* ─── Sections List ─── */\n.pages-list-pro {\n    margin: 0 auto;\n    max-width: 1600px;\n    text-align: center;\n    padding: 24px 0;\n    list-style: none;\n    width: 100%;\n}\n\n/* ─── Section Title ─── */\n.pages-section-title {\n    font-size: 26px;\n    font-weight: 700;\n    margin-bottom: 24px;\n    color: var(--primary);\n    text-align: left;\n    padding-left: 4px;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.pages-section-title::before {\n    content: '';\n    display: inline-block;\n    width: 5px;\n    height: 26px;\n    background: var(--gradient-btn);\n    border-radius: 4px;\n    flex-shrink: 0;\n}\n\n/* ─── Grid ─── */\n.pages-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n    gap: 24px;\n    width: 100%;\n    margin: 0 auto;\n}\n\n@media (min-width: 1400px) {\n    .pages-grid {\n        grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n        max-width: 1600px;\n    }\n}\n\n/* ─── Card ─── */\n.page-card-modern {\n    background: var(--bg-card);\n    border-radius: var(--radius);\n    border: 1px solid var(--border);\n    box-shadow: var(--shadow-sm);\n    overflow: hidden;\n    transition: all 0.3s ease;\n    cursor: pointer;\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n}\n\n.page-card-modern:hover {\n    transform: translateY(-6px);\n    box-shadow: var(--shadow-lg);\n    border-color: rgba(40, 116, 240, 0.30);\n}\n\n/* ─── Card Image Area ─── */\n.page-card-image-container {\n    position: relative;\n    width: 100%;\n    height: 148px;\n    overflow: hidden;\n    background: var(--gradient-hero);\n}\n\n.page-card-image {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    transition: transform 0.35s ease;\n}\n\n.page-card-modern:hover .page-card-image {\n    transform: scale(1.08);\n}\n\n.page-card-placeholder {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: var(--gradient-hero);\n}\n\n.page-card-placeholder-icon {\n    font-size: 64px;\n    opacity: 0.65;\n}\n\n.page-card-overlay {\n    position: absolute;\n    inset: 0;\n    background: linear-gradient(180deg, rgba(40,116,240,0.55) 0%, rgba(118,75,162,0.70) 100%);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    opacity: 0;\n    transition: opacity 0.3s ease;\n}\n\n.page-card-modern:hover .page-card-overlay {\n    opacity: 1;\n}\n\n.page-card-view-text {\n    color: #fff;\n    font-weight: 700;\n    font-size: 15px;\n    text-transform: uppercase;\n    letter-spacing: 1.5px;\n    background: rgba(255,255,255,0.15);\n    padding: 8px 20px;\n    border-radius: 50px;\n    backdrop-filter: blur(4px);\n    border: 1.5px solid rgba(255,255,255,0.45);\n}\n\n/* ─── Card Body ─── */\n.page-card-content {\n    padding: 20px;\n    flex-grow: 1;\n    display: flex;\n    flex-direction: column;\n    background: linear-gradient(180deg, #fff 0%, #f8faff 100%);\n}\n\n.page-card-title {\n    font-size: 18px;\n    font-weight: 700;\n    color: var(--text-primary);\n    margin: 0 0 8px;\n    cursor: pointer;\n    transition: color 0.2s ease;\n}\n\n.page-card-title:hover {\n    color: var(--primary);\n}\n\n.page-card-description {\n    font-size: 13.5px;\n    color: var(--text-secondary);\n    line-height: 1.6;\n    margin: 0 0 16px;\n    flex-grow: 1;\n}\n\n/* ─── Card Actions ─── */\n.page-card-actions {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 10px;\n    margin-top: auto;\n}\n\n.page-card-edit-btn,\n.page-card-view-btn {\n    background: var(--gradient-btn);\n    color: #fff;\n    border: none;\n    padding: 9px 18px;\n    border-radius: 8px;\n    font-size: 13.5px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.22s ease;\n    flex: 1;\n    box-shadow: 0 2px 8px rgba(40, 116, 240, 0.20);\n}\n\n.page-card-edit-btn:hover,\n.page-card-view-btn:hover {\n    background: linear-gradient(135deg, #1a5fcf 0%, #3b7df5 100%);\n    transform: translateY(-2px);\n    box-shadow: 0 6px 16px rgba(40, 116, 240, 0.35);\n}\n\n.page-card-delete-btn {\n    background: transparent;\n    border: 1.5px solid var(--border);\n    padding: 9px 12px;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: all 0.22s ease;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.page-card-delete-btn:hover {\n    background: #fff0f0;\n    border-color: #ff6161;\n    transform: translateY(-2px);\n    box-shadow: 0 4px 12px rgba(255, 97, 97, 0.20);\n}\n\n/* ─── States ─── */\n.loading-state,\n.empty-state {\n    text-align: center;\n    padding: 48px 20px;\n    color: var(--text-secondary);\n    font-size: 16px;\n}\n\n/* ─── More Button ─── */\n.more-button-modern {\n    background: #fff;\n    border: 1.5px solid var(--border);\n    color: var(--text-secondary);\n    padding: 12px 28px;\n    border-radius: 50px;\n    font-size: 14px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.22s ease;\n    margin: 32px auto;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    box-shadow: var(--shadow-sm);\n}\n\n.more-button-modern:hover {\n    background: #f0f5ff;\n    border-color: var(--primary);\n    color: var(--primary);\n    transform: translateY(-2px);\n    box-shadow: var(--shadow-md);\n}\n\n/* ─── Two-Column Layout ─── */\n.pages-two-columns {\n    display: flex;\n    flex-direction: row;\n    gap: 36px;\n    width: 100%;\n    margin-top: 16px;\n    align-items: flex-start;\n    box-sizing: border-box;\n}\n\n.pages-two-columns .pages-list-pro {\n    flex: 1 1 0;\n    min-width: 0;\n    background: var(--bg-panel);\n    border-radius: var(--radius-lg);\n    padding: 28px 24px 24px;\n    border-top: 4px solid var(--primary);\n    box-shadow: var(--shadow-sm);\n    transition: box-shadow 0.25s;\n    box-sizing: border-box;\n    overflow: hidden;\n    margin: 0;\n}\n\n.pages-two-columns .pages-list-pro:hover {\n    box-shadow: var(--shadow-md);\n}\n\n.pages-two-columns .pages-grid {\n    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));\n    gap: 16px;\n}\n\n.pages-two-columns .pages-section-title {\n    font-size: 20px;\n    font-weight: 700;\n    color: var(--primary);\n    margin-bottom: 20px;\n    letter-spacing: 0.2px;\n}\n\n/* ─── Pro Card List ─── */\n.page-card-pro,\n.page-card-pro-i {\n    display: flex;\n    justify-content: space-between;\n    gap: 10px;\n    padding: 12px 16px;\n    margin: 10px auto;\n    border-radius: 10px;\n    background: #fff;\n    border: 1px solid var(--border);\n    width: 100%;\n    min-width: 400px;\n    box-sizing: border-box;\n    transition: box-shadow 0.2s, transform 0.2s;\n}\n\n.page-card-pro:hover,\n.page-card-pro-i:hover {\n    box-shadow: var(--shadow-sm);\n    transform: translateY(-2px);\n}\n\n.view-btn-page,\n.delete-btn-page-list,\n.edit-btn-page-dete {\n    background-color: transparent;\n    font-size: 12px;\n    padding: 4px 8px;\n    border-radius: 6px;\n    transition: background 0.15s, color 0.15s;\n    cursor: pointer;\n    border: none;\n}\n\n.view-btn-page:hover       { background: #e8f0fe; color: var(--primary); }\n.delete-btn-page-list:hover{ background: #fff0f0; color: #e53935; }\n.edit-btn-page-dete:hover  { background: #e8f0fe; color: var(--primary); }\n\n.btn-view-delete {\n    display: flex;\n    flex-direction: row;\n    gap: 6px;\n    justify-content: flex-end;\n    align-items: center;\n}\n\n/* ─── Close Button ─── */\n.close-btn-page-list {\n    background-color: transparent;\n    color: white;\n    padding: 4px;\n    border: none;\n    cursor: pointer;\n    border-radius: 50%;\n    transition: background 0.15s;\n}\n\n.close-btn-page-list:hover {\n    background-color: rgba(255,255,255,0.15);\n    color: #ff6b6b;\n}\n\n/* ─── Flipkart-style Buttons ─── */\n.flipkart-button-primary {\n    background: var(--gradient-btn);\n    color: #fff;\n    border: none;\n    padding: 10px 22px;\n    border-radius: 8px;\n    font-weight: 600;\n    cursor: pointer;\n    box-shadow: 0 2px 8px rgba(40, 116, 240, 0.25);\n    transition: all 0.25s ease;\n}\n\n.flipkart-button-primary:hover {\n    background: linear-gradient(135deg, #1a5fcf 0%, #3b7df5 100%);\n    box-shadow: 0 6px 18px rgba(40, 116, 240, 0.35);\n    transform: translateY(-1px);\n}\n\n.flipkart-button-primary:disabled {\n    background: #cccccc;\n    cursor: not-allowed;\n    box-shadow: none;\n}\n\n.flipkart-button-secondary {\n    background: #fff;\n    color: var(--primary);\n    border: 1.5px solid var(--primary);\n    padding: 10px 22px;\n    border-radius: 8px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.22s ease;\n}\n\n.flipkart-button-secondary:hover {\n    background: #eef3ff;\n    transform: translateY(-1px);\n}\n\n.flipkart-button-secondary.small {\n    padding: 5px 12px;\n    font-size: 12px;\n}\n\n.flipkart-button-danger {\n    background: linear-gradient(135deg, #ff6161 0%, #e53935 100%);\n    color: #fff;\n    border: none;\n    padding: 10px 22px;\n    border-radius: 8px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.22s ease;\n    box-shadow: 0 2px 8px rgba(229, 57, 53, 0.25);\n}\n\n.flipkart-button-danger:hover {\n    background: linear-gradient(135deg, #e53935 0%, #c62828 100%);\n    transform: translateY(-1px);\n    box-shadow: 0 6px 16px rgba(229, 57, 53, 0.35);\n}\n\n.flipkart-button-danger.small {\n    padding: 5px 12px;\n    font-size: 12px;\n}\n\n/* ─── Flipkart Modal ─── */\n.flipkart-modal-overlay {\n    position: fixed;\n    inset: 0;\n    background: rgba(15, 20, 50, 0.60);\n    backdrop-filter: blur(6px);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n}\n\n.flipkart-modal-container {\n    background: #fff;\n    border-radius: var(--radius-lg);\n    width: 100%;\n    max-width: 600px;\n    box-shadow: 0 24px 64px rgba(40, 116, 240, 0.22);\n    border-top: 5px solid var(--primary);\n    animation: flipkartModalFadeIn 0.3s cubic-bezier(.22,.68,0,1.3);\n}\n\n.flipkart-modal-container.small {\n    max-width: 420px;\n}\n\n@keyframes flipkartModalFadeIn {\n    from { opacity: 0; transform: translateY(-20px) scale(0.97); }\n    to   { opacity: 1; transform: translateY(0) scale(1); }\n}\n\n.flipkart-modal-header {\n    padding: 24px 36px;\n    border-bottom: 1px solid var(--border);\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    background: linear-gradient(135deg, #f4f7ff 0%, #eef1ff 100%);\n    border-radius: var(--radius-lg) var(--radius-lg) 0 0;\n}\n\n.flipkart-modal-header h3 {\n    margin: 0;\n    font-size: 22px;\n    font-weight: 700;\n    color: var(--text-primary);\n}\n\n.flipkart-modal-close {\n    background: none;\n    border: none;\n    font-size: 22px;\n    cursor: pointer;\n    color: var(--text-secondary);\n    padding: 4px 8px;\n    border-radius: 50%;\n    line-height: 1;\n    transition: background 0.2s, color 0.2s;\n}\n\n.flipkart-modal-close:hover {\n    background: #ffe8e8;\n    color: #e53935;\n}\n\n.flipkart-modal-body {\n    padding: 28px 36px;\n    max-height: 60vh;\n    overflow-y: auto;\n}\n\n.scrollable-content {\n    max-height: 50vh;\n    overflow-y: auto;\n}\n\n.flipkart-modal-footer {\n    padding: 18px 36px;\n    border-top: 1px solid var(--border);\n    display: flex;\n    justify-content: flex-end;\n    gap: 12px;\n    background: #fafbff;\n    border-radius: 0 0 var(--radius-lg) var(--radius-lg);\n}\n\n/* ─── Form Inputs (Flipkart style) ─── */\n.flipkart-form-group {\n    margin-bottom: 18px;\n}\n\n.flipkart-form-group label {\n    display: block;\n    margin-bottom: 8px;\n    font-size: 14px;\n    color: var(--text-primary);\n    font-weight: 600;\n}\n\n.flipkart-input {\n    width: 100%;\n    padding: 11px 14px;\n    border: 1.5px solid var(--border);\n    border-radius: 10px;\n    font-size: 14px;\n    background: #f8faff;\n    color: var(--text-primary);\n    transition: border-color 0.2s, box-shadow 0.2s;\n    outline: none;\n    box-sizing: border-box;\n}\n\n.flipkart-input:focus {\n    border-color: var(--primary);\n    box-shadow: 0 0 0 3px rgba(40, 116, 240, 0.12);\n    background: #fff;\n}\n\n.flipkart-textarea {\n    width: 100%;\n    padding: 11px 14px;\n    border: 1.5px solid var(--border);\n    border-radius: 10px;\n    font-size: 14px;\n    min-height: 90px;\n    resize: vertical;\n    background: #f8faff;\n    color: var(--text-primary);\n    transition: border-color 0.2s, box-shadow 0.2s;\n    outline: none;\n    box-sizing: border-box;\n    margin-bottom: 8px;\n}\n\n.flipkart-textarea:focus {\n    border-color: var(--primary);\n    box-shadow: 0 0 0 3px rgba(40, 116, 240, 0.12);\n    background: #fff;\n}\n\n.flipkart-file-input {\n    width: 100%;\n    padding: 8px 0;\n    font-size: 14px;\n}\n\n.paragraph-group {\n    margin-bottom: 14px;\n}\n\n/* ─── Type Selection Buttons ─── */\n.btn-select-type {\n    width: 180px;\n    height: 130px;\n    border-radius: var(--radius);\n    border: none;\n    padding: 20px;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    box-shadow: 0 6px 20px rgba(0,0,0,0.14);\n}\n\n.firm-btn {\n    background: linear-gradient(135deg, #4b6cb7 0%, #182848 100%);\n    color: #fff;\n}\n\n.individual-btn {\n    background: linear-gradient(135deg, #ff7e5f 0%, #feb47b 100%);\n    color: #fff;\n}\n\n.btn-select-type:hover {\n    transform: translateY(-6px);\n    box-shadow: 0 14px 32px rgba(0,0,0,0.22);\n}\n\n.btn-icon        { font-size: 36px;  margin-bottom: 10px; }\n.btn-text        { font-size: 20px;  font-weight: 700; margin-bottom: 8px; }\n.btn-description { font-size: 13px;  opacity: 0.88; }\n\n/* ─── Back Button ─── */\n.btn-back-outline {\n    background: transparent;\n    border: 2px solid var(--border);\n    color: var(--text-secondary);\n    padding: 9px 22px;\n    border-radius: 50px;\n    font-size: 14px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.25s ease;\n    margin-top: 20px;\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n}\n\n.btn-back-outline:hover {\n    background: #eef1ff;\n    border-color: var(--primary);\n    color: var(--primary);\n    transform: translateY(-1px);\n}\n\n/* ─── Validation ─── */\n.error-field {\n    border: 1.5px solid #e53935 !important;\n    background: #fff8f8 !important;\n}\n\n.error-message {\n    color: #e53935;\n    font-size: 12px;\n    margin-top: 5px;\n    display: flex;\n    align-items: center;\n    gap: 4px;\n}\n\n.required-star { color: #e53935; }\n\n/* ─── Responsive ─── */\n@media (max-width: 900px) {\n    .pages-two-columns {\n        flex-direction: column;\n        gap: 24px;\n    }\n\n    .pages-two-columns .pages-list-pro {\n        width: 100%;\n    }\n}\n\n@media (max-width: 1024px) and (min-width: 768px) {\n    .pages-div-out      { margin-top: 70px; padding-top: 28px; }\n    .pages-create-display { padding: 30px 40px; }\n}\n\n/* ─── MOBILE: ≤ 768px ─── */\n@media (max-width: 768px) {\n    .pages-div-out        { margin-top: 20px; padding-top: 20px; margin-bottom: 50px; }\n    .pages-create-display { padding: 0px 16px 20px; }\n    .pages-grid           { grid-template-columns: repeat(auto-fill, minmax(130px, 1fr)); gap: 10px; }\n    .page-card-image-container { height: 90px; }\n    .page-card-placeholder-icon { font-size: 40px; }\n    .page-card-content    { padding: 10px; }\n    .page-card-title      { font-size: 13px; margin-bottom: 4px; }\n    .page-card-description{\n        font-size: 11.5px;\n        line-height: 1.4;\n        margin-bottom: 10px;\n        -webkit-line-clamp: 2;\n        display: -webkit-box;\n        -webkit-box-orient: vertical;\n        overflow: hidden;\n    }\n    .page-card-edit-btn,\n    .page-card-view-btn   { padding: 6px 8px; font-size: 11.5px; }\n    .page-card-delete-btn { padding: 6px 8px; }\n    .pages-section-title  { font-size: 20px; }\n    .text-page            { margin-left: 0; }\n    .form-actions-page,\n    .form-actions-page-edit { gap: 10px; justify-content: center; }\n    .flipkart-modal-body  { padding: 20px 24px; }\n    .flipkart-modal-header { padding: 18px 24px; }\n    .flipkart-modal-footer { padding: 14px 24px; }\n\n    .pages-two-columns {\n        flex-direction: column;\n        gap: 16px;\n    }\n\n    .pages-two-columns .pages-list-pro {\n        width: 100%;\n        padding: 16px 12px;\n    }\n\n    .pages-two-columns .pages-grid {\n        grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));\n        gap: 10px;\n    }\n}\n\n/* ─── MOBILE: ≤ 480px ─── */\n@media (max-width: 480px) {\n    .pages-div-out        { margin-top: 35px; padding-top: 16px; }\n    .pages-create-display { padding: 5px 10px 18px; }\n    .pages-grid           { grid-template-columns: 1fr 1fr; gap: 8px; }\n    .page-card-image-container { height: 80px; }\n    .page-card-placeholder-icon { font-size: 34px; }\n    .page-card-content    { padding: 8px 10px; }\n    .page-card-title      { font-size: 12px; margin-bottom: 3px; }\n    .page-card-description{\n        font-size: 11px;\n        line-height: 1.35;\n        margin-bottom: 8px;\n        -webkit-line-clamp: 2;\n        display: -webkit-box;\n        -webkit-box-orient: vertical;\n        overflow: hidden;\n    }\n    .page-card-actions    { gap: 5px; }\n    .page-card-edit-btn,\n    .page-card-view-btn   { padding: 5px 6px; font-size: 11px; }\n    .page-card-delete-btn { padding: 5px 8px; }\n    .pages-section-title  { font-size: 16px; margin-bottom: 12px; }\n    .btn-create-page      { padding: 10px 20px; font-size: 13px; min-width: 150px; margin-bottom: 0px; }\n    .form-actions-page button,\n    .form-actions-page-delete button,\n    .form-actions-page-edit button { padding: 9px 16px; font-size: 13px; }\n    .page-card-pro,\n    .page-card-pro-i      { min-width: unset; flex-wrap: wrap; }\n    .view-btn-page,\n    .edit-btn-page-dete   { width: 100%; padding: 6px; margin: 2px 0; }\n    .pages-two-columns .pages-grid {\n        grid-template-columns: 1fr 1fr;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
